/**
 * Get the total number of rows in the given page.
 * 
 * @param {any} page 
 * @param {any} total 
 * @param {any} defaultSize 
 */
export function getNumberOfRows(page, total, defaultSize) {
  const numberOfPages = Math.floor((total + defaultSize - 1) / defaultSize);
  const start = (page * defaultSize) - (defaultSize - 1);
  const end = Math.min(start + defaultSize - 1, total);

  return (end - start + 1);
}



// WEBPACK FOOTER //
// ./src/utils/paginator.js